var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  disabled: !this.vulnsourceEnabled && !this.nvdFeedsUrl,
                  id: "vulnsourceEnabled",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.vulnsourceEnabled,
                  callback: function ($$v) {
                    _vm.vulnsourceEnabled = $$v
                  },
                  expression: "vulnsourceEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("admin.vulnsource_nvd_enable")) + "\n    "
          ),
          _c("hr"),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("admin.vulnsource_nvd_desc")) + "\n    "
          ),
          _c("br"),
          _c("br"),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("admin.vulnsource_nvd_notice")) + "\n    "
          ),
          _c("hr"),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "nvd-feeds-url",
              label: _vm.$t("admin.vulnsource_nvd_feeds_url"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "text",
              lazy: "true",
            },
            model: {
              value: _vm.nvdFeedsUrl,
              callback: function ($$v) {
                _vm.nvdFeedsUrl = $$v
              },
              expression: "nvdFeedsUrl",
            },
          }),
          _c("hr"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "nvdApiEnabled", color: "primary", label: "" },
                model: {
                  value: _vm.nvdApiEnabled,
                  callback: function ($$v) {
                    _vm.nvdApiEnabled = $$v
                  },
                  expression: "nvdApiEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.nvd_enable_mirroring_via_api")) +
              "\n    "
          ),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-question-circle" }, [_vm._v(" ")]),
            _c(
              "a",
              { attrs: { href: _vm.nvdApiWhyEnableUrl, target: "_blank" } },
              [_vm._v(_vm._s(_vm.$t("admin.nvd_why_enable_api_help")))]
            ),
          ]),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  disabled: !this.nvdApiEnabled,
                  id: "nvdApiDownloadFeeds",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.nvdApiDownloadFeeds,
                  callback: function ($$v) {
                    _vm.nvdApiDownloadFeeds = $$v
                  },
                  expression: "nvdApiDownloadFeeds",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.nvd_additionally_download_feeds")) +
              "\n    "
          ),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-question-circle" }, [_vm._v(" ")]),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("admin.nvd_additionally_download_feeds_help")) +
                "\n      "
            ),
            _c("code", [_vm._v("/mirror/nvd")]),
          ]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "nvdApiEndpoint",
              label: "API endpoint",
              "input-group-size": "mb-3",
              lazy: "true",
            },
            model: {
              value: _vm.nvdApiEndpoint,
              callback: function ($$v) {
                _vm.nvdApiEndpoint = $$v
              },
              expression: "nvdApiEndpoint",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "nvdApiKey",
              label: "API key",
              "input-group-size": "mb-3",
              type: "password",
              lazy: "true",
            },
            model: {
              value: _vm.nvdApiKey,
              callback: function ($$v) {
                _vm.nvdApiKey = $$v
              },
              expression: "nvdApiKey",
            },
          }),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-question-circle" }, [_vm._v(" ")]),
            _c(
              "a",
              { attrs: { href: _vm.nvdApiRequestApiKeyUrl, target: "_blank" } },
              [_vm._v(_vm._s(_vm.$t("admin.nvd_request_api_key_help")))]
            ),
          ]),
          _c(
            "b-form-group",
            { attrs: { label: _vm.$t("admin.nvd_api_last_modification") } },
            [
              _c(
                "b-input-group",
                [
                  _c("b-form-datepicker", {
                    attrs: {
                      id: "nvdApiLastModifiedDate",
                      "date-format-options": {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                      },
                      min: _vm.nvdApiLastModifiedDateMin,
                      max: _vm.nvdApiLastModifiedDateMax,
                      locale: "en-GB",
                      "reset-button": true,
                      "show-decade-nav": true,
                    },
                    model: {
                      value: _vm.nvdApiLastModifiedDate,
                      callback: function ($$v) {
                        _vm.nvdApiLastModifiedDate = $$v
                      },
                      expression: "nvdApiLastModifiedDate",
                    },
                  }),
                  _c("b-form-timepicker", {
                    attrs: {
                      id: "nvdApiLastModifiedTime",
                      locale: "en-GB",
                      "reset-button": true,
                    },
                    model: {
                      value: _vm.nvdApiLastModifiedTime,
                      callback: function ($$v) {
                        _vm.nvdApiLastModifiedTime = $$v
                      },
                      expression: "nvdApiLastModifiedTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-question-circle" }, [_vm._v(" ")]),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("admin.nvd_api_last_modification_help")) +
                "\n    "
            ),
          ]),
          _c("p", { staticClass: "font-sm text-muted" }, [
            _c("span", { staticClass: "fa fa-warning" }, [_vm._v(" ")]),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("admin.nvd_api_last_modification_warning")) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: {
                disabled: this.vulnsourceEnabled && !this.nvdFeedsUrl,
                variant: "outline-primary",
              },
              on: { click: _vm.saveChanges },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("message.update")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }